export default __webpack_public_path__ + "static/media/complementary--caravan-trailers--g3.1ed469ef.png";